import React from 'react';
import Home from './pages/Home';
import './assets/styles/global.css';

function App() {
  return (
    <div className="app">
      <Home />
    </div>
  );
}

export default App;